<template>
<div style="width:300px">
  <el-button @click="extend_drawer" @touchend="extend_drawer" type="primary" style="background-color:transparent; border-style:none; border-color:transparent">
<!--            :autofocus="true"-->
    <p style="font-size: 16px" class="touch">
      AI工具合集
    </p>
  </el-button>
  <el-drawer
    title="AI工具合集"
    :visible.sync="drawer"
    direction="ttb"
    :wrapperClosable="true"
    :modal="false"
    :withHeader="false"
    :modal-append-to-body="false"
  >
      <div style="display: flex" id="ex_panel">

        <ul style="height:100%; justify-items: center">
          <a href="http://www.ai-universe.cn/label.online">
          <span>SAM图像分割</span>
          <el-image :src="require('../assets/sam.png')"
                    alt="sam图像分割"
                    style="height:200px; display: flex" fit="cover">
          </el-image>
          </a>
        </ul>
      </div>
  </el-drawer>
  <div id="drawer_mask" @click="mask_click" @touchend="mask_click">
  </div>
</div>
</template>



<style scoped>
#ex_panel{
  background: linear-gradient(rgba(255,255,255,0.1), pink 50%, rgba(255,255,255,0.1));
  backdrop-filter: blur(250px)

}

.touch:hover{
  cursor: pointer;
}
.el-drawer__wrapper {
  position: fixed;
  left: 0px;
  //bottom:0px;
  width:100%;

}

#drawer_mask{
  height:100%;
  width: 100%;
  position: fixed;
  top: 0px;
  left:0px;
  z-index: -1;
  transform: translateZ(1px);
  -webkit-transform: translateZ(1px);
  -moz-transform: transateZ(1px);
  -o-transform: translateZ(1px);
}

img{
  height: 100%;
  width: 100%;
}

</style>


<script>
import $ from "jquery"

// global var

export default {
  name: "AiList",
  data() {
    return {
      drawer: false
    }
  },
  methods: {
    mask_click() {
      this.drawer = false;
      let temp_element = $("#drawer_mask")[0];
      temp_element.style.zIndex="-1";
    },
    extend_drawer(){
      this.drawer = true;
      // console.log(temp_element.style.zIndex)

      let temp_element = $("#drawer_mask")[0];
      temp_element.style.zIndex = "10";
    }
  }
}




</script>



// WEBPACK FOOTER //
// src/components/AIList.vue